export const runInSequence = (promises: (() => Promise<any>)[]) => {
	return promises.reduce(
		(acc, nextPromise) => acc.then(() => nextPromise()),
		Promise.resolve([]),
	);
};
